var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.active,
          expression: "active"
        }
      ]
    },
    [
      _c("div", { staticClass: "category d-flex d-flex-row flex-nowrap" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "edit-item verticalAlignMiddle textAlignRight" },
          [
            _c(
              "a",
              {
                attrs: { href: "" },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    _vm.active = !_vm.active
                  }
                }
              },
              [_c("i", { staticClass: "fa fa-pencil" })]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("hr", { staticStyle: { "margin-top": "5px" } }),
      _vm._v(" "),
      _vm.active
        ? _c(
            "div",
            { staticClass: "category-content" },
            [
              !_vm.edit
                ? _c("div", { staticClass: "editAvatarPreview" }, [
                    _vm.hasAvatar
                      ? _c(
                          "div",
                          {
                            staticClass: "deleteImageButton",
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                _vm.remove()
                              }
                            }
                          },
                          [_c("i", { staticClass: "fa fa-2x fa-close" })]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "roundImageContainer" }, [
                      _c("div", {
                        ref: "previewImage",
                        staticClass: "roundImage roundImageOrigin",
                        style: {
                          "background-image":
                            "url(" + _vm.getCurrentImage(this.croppedUrl) + ")"
                        }
                      })
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.edit
                ? _c("div", { staticClass: "editAvatarPreview" }, [
                    _vm.hasAvatar
                      ? _c(
                          "div",
                          {
                            staticClass: "deleteImageButton",
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                _vm.remove()
                              }
                            }
                          },
                          [_c("i", { staticClass: "fa fa-2x fa-close" })]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "roundImageContainer" }, [
                      _c("div", {
                        ref: "previewImage2",
                        staticClass: "roundImage roundImageOrigin"
                      })
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "file-upload",
                {
                  ref: "upload",
                  staticClass: "btn btn-white teaserButton width100",
                  staticStyle: {
                    "margin-bottom": "20px",
                    "margin-top": "10px"
                  },
                  attrs: {
                    extensions: "gif,jpg,jpeg,png,webp",
                    accept: "image/png,image/gif,image/jpeg,image/webp",
                    name: "image",
                    "post-action": "/upload/image",
                    drop: _vm.drop,
                    multiple: _vm.multiple
                  },
                  on: {
                    "input-filter": _vm.inputFilter,
                    "input-file": _vm.inputFile
                  },
                  model: {
                    value: _vm.files,
                    callback: function($$v) {
                      _vm.files = $$v
                    },
                    expression: "files"
                  }
                },
                [_vm._v("\n            Bild auswählen\n        ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "clearfix" },
                _vm._l(_vm.files, function(file) {
                  return _c(
                    "div",
                    {
                      key: file.id,
                      class: [
                        "fullImageContainer",
                        _vm.hasError ? "error" : "temp",
                        "dropzone",
                        {
                          active:
                            _vm.$refs.upload && _vm.$refs.upload.dropActive
                        }
                      ]
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "fullImageContainerContent textAlignCenter verticalAlignMiddle"
                        },
                        [
                          file.thumb
                            ? _c("img", {
                                ref: "editImage",
                                refInFor: true,
                                staticClass: "width100",
                                attrs: { src: file.thumb },
                                on: { cropmove: _vm.crop }
                              })
                            : _vm._e()
                        ]
                      )
                    ]
                  )
                })
              ),
              _vm._v(" "),
              _vm.files.length == 0
                ? _c(
                    "div",
                    {
                      class: [
                        "textAlignCenter",
                        "clearfix",
                        "fullImageContainer",
                        "dropzone",
                        {
                          active:
                            _vm.$refs.upload && _vm.$refs.upload.dropActive
                        }
                      ]
                    },
                    [_vm._m(1)]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasError
                ? _c("div", { staticClass: "errorBox" }, [
                    _vm._v(
                      "Der ausgewählte Bildausschnitt ist zu groß, wähle einen kleineren Ausschnitt oder verwende ein anderes Bild."
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "buttonBlockContainerRight" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-white teaserButton width100",
                    attrs: { type: "button" },
                    on: { click: _vm.cancel }
                  },
                  [_vm._v("Abbrechen")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-white teaserButton width100",
                    attrs: { type: "button", disabled: _vm.uploadHasErrors() },
                    on: { click: _vm.save }
                  },
                  [_vm._v("Speichern")]
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "modalDialog",
          staticClass: "modal fade",
          attrs: { tabindex: "-1", role: "dialog" }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog old-modal-dialog",
              attrs: { role: "document" }
            },
            [
              _c("div", { staticClass: "modal-content" }, [
                _vm._m(2),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _vm._v(
                    "\n                Möchten Sie das Profilbild wirklich löschen?\n            "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: { type: "button", "data-dismiss": "modal" }
                    },
                    [_vm._v("Nein")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: { click: _vm.finishRemove }
                    },
                    [_vm._v("Ja")]
                  )
                ])
              ])
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "category-item verticalAlignMiddle" }, [
      _c("h2", [_vm._v("Profilbild")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fullImageContainerContent" }, [
      _c("div", { staticClass: "textAlignCenter verticalAlignMiddle" }, [
        _c("div", [_c("i", { staticClass: "fa fa-picture-o fa-2x" })]),
        _vm._v(" "),
        _c("div", [
          _vm._v("\n                        Dein Bild\n                    ")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h5", { staticClass: "modal-title" }, [_vm._v("Bestätigung")]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3b506f0a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b506f0a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProfileAvatarEditor.vue
// module id = 503
// module chunks = 2